import { Injectable } from '@angular/core';
import { ReplaySubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class NudgeService {
  constructor(
    private _http: HttpClient,
    private localStorageService: LocalStorageService,
  ) {}

  private nudgeOverview = this.localStorageService.get('nudgeOverallSwitcher')
    ? 'nudgeOverview=true'
    : null;

  updateNudgeOverall() {
    this.nudgeOverview = this.localStorageService.get('nudgeOverallSwitcher')
      ? 'nudgeOverview=true'
      : null;
  }

  reFetch(obj: any) {
    this.fetch(obj);
  }

  private fetch(obj: any) {
    var params =
      '?startDate=' +
      obj.startDate +
      '&endDate=' +
      obj.endDate +
      '&rate=' +
      obj.rate +
      '&selectedRangeValue=' +
      obj.selectedRangeValue +
      '&target=' +
      obj.target;

    if (obj.selectedFilter != 'overall' && obj.selectedFilter != '') {
      params += `&visitType=${obj.selectedFilter}`;
    }

    if (obj.selectedPlatform != 'overall' && obj.selectedPlatform != '') {
      params += `&device=${obj.selectedPlatform}`;
    }

    this.updateNudgeOverall();
    if (this.nudgeOverview) {
      params += `&${this.nudgeOverview}`;
    }

    return this._http.get('/getincentivesstats' + params);
  }
  private getRpvDataInc(obj: any) {
    var params =
      '?startDate=' +
      obj.startDate +
      '&endDate=' +
      obj.endDate +
      '&rate=' +
      obj.rate +
      '&selectedRangeValue=' +
      obj.selectedRangeValue +
      '&target=' +
      obj.target;

    this.updateNudgeOverall();
    if (this.nudgeOverview) {
      params += `&${this.nudgeOverview}`;
    }

    return this._http.get('/rpvline' + params);
  }

  public getNumberInfo(data: any) {
    var params = '?startDate=' + data.sDataRange + '&target=' + data.target;

    this.updateNudgeOverall();
    if (this.nudgeOverview) {
      params += `&${this.nudgeOverview}`;
    }

    return this._http.get('/statisticsnumbers' + params);
  }

  private getFreqData(obj: any) {
    var params =
      '?startDate=' +
      obj.startDate +
      '&endDate=' +
      obj.endDate +
      '&device=' +
      obj.device +
      '&incentiveSector=' +
      obj.incentiveSector +
      '&siteID=' +
      obj.siteID +
      '&incentiveTypes=' +
      obj.incentiveTypes +
      '&ruleIDs=' +
      obj.ruleIDs +
      '&target=' +
      obj.target;

    this.updateNudgeOverall();
    if (this.nudgeOverview) {
      params += `&${this.nudgeOverview}`;
    }

    return this._http.get('/incentivesfrequency' + params);
  }

  getCustomerRulesTarget(target: any) {
    if (typeof target == 'undefined') {
      var params = '';
    } else {
      var params = '?target=' + target;
    }

    this.updateNudgeOverall();
    if (this.nudgeOverview) {
      params += `&${this.nudgeOverview}`;
    }

    return this._http.get<any[]>('/customerrules' + params);
  }

  getAllIncentives(target: any): Observable<any[]> {
    let params = 'target=' + target;

    this.updateNudgeOverall();
    if (this.nudgeOverview) {
      params += `&${this.nudgeOverview}`;
    }

    return this._http.get<any[]>('/incentives?' + params);
  }

  getAllIncentivesTarget(target: any): Observable<any[]> {
    if (typeof target == 'undefined') {
      var params = '';
    } else {
      var params = '?target=' + target;
    }

    this.updateNudgeOverall();
    if (this.nudgeOverview) {
      params += `&${this.nudgeOverview}`;
    }

    return this._http.get<any[]>('/incentives' + params);
  }

  getIncentivesStats(obj: any) {
    return this.fetch(obj);
  }

  getRpvData(obj: any) {
    return this.getRpvDataInc(obj);
  }

  getFreqBarChart(obj: any) {
    return this.getFreqData(obj);
  }

  getVariants(data: any) {
    var params = '?target=' + data;

    this.updateNudgeOverall();
    if (this.nudgeOverview) {
      params += `&${this.nudgeOverview}`;
    }

    return this._http.get('/variants' + params);
  }

  getFreqBarChartNudgeLite(obj: any) {
    var params =
      '?startDate=' +
      obj.startDate +
      '&endDate=' +
      obj.endDate +
      '&device=' +
      obj.device +
      '&siteID=' +
      obj.siteID +
      '&ruleIDs=' +
      obj.ruleIDs +
      '&target=' +
      obj.target +
      '&rate=' +
      obj.rate;

    this.updateNudgeOverall();
    if (this.nudgeOverview) {
      params += `&${this.nudgeOverview}`;
    }

    return this._http.get('/nudgeAnalyticsFrequency' + params);
  }
}
